import { useQuery } from 'react-query';
import { apiService } from '~services/ApiService';
import { useUserStore } from '~providers/userStore/zustand';

export interface Notification {
  id: string;
  title: string;
  body: string;
  uid: string;
  notification_type: string;
  status: string;
  data: {
    event_id?: string;
    [key: string]: any;
  } | null;
  created_at: string;
  updated_at: string;
}

export interface NotificationsResponse {
  notifications: Notification[];
  hasMore: boolean;
  total: number;
}

export const useGetNotifications = () => {
  const user = useUserStore(state => state.user);
  
  return useQuery<Notification[], Error>(
    'notifications',
    async () => {
      const response = await apiService.get<Notification[]>('notifications/all');
      return response;
    },
    {
      enabled: !!user, // Only run when user is available
      staleTime: 30000, // 30 seconds
      refetchOnWindowFocus: true,
    }
  );
};